import React, { Component } from 'react'
import PropTypes from 'prop-types'
import IPropTypes from 'react-immutable-proptypes'
import ReactResizeDetector from 'react-resize-detector'
import { DropTarget } from 'react-dnd'
import _ from 'lodash'

import hocConnect from './hocConnect'
import hocDialog from '../../../../../../services/dialog/hocDialog'

import EmptyContent from './components/EmptyContent'
import TableContent from './components/TableContent'

import { DND_TYPE } from '../../../../../../dnd/constants'

import './style.scss'

const collectDr = (connectDrag) => ({
    connectDropTarget: connectDrag.dropTarget(),
})

const groupStackTarget = {
    drop: (props, monitor) => {
        const {
            insertMemberToGroup,
            groupStackState: { activeGroup },
            members,
        } = props
        const { entity } = monitor.getItem()
        const entId = entity.get('entId')

        if (!_.find(members, (member) => _.toString(member.get('entId')) === _.toString(entId))) {
            insertMemberToGroup(activeGroup, entId)
        }
    },
}

@hocDialog
@hocConnect
@DropTarget(DND_TYPE.ENTITY, groupStackTarget, collectDr)
export default class Content extends Component {
    static propTypes = {
        connectDropTarget: PropTypes.func.isRequired,
        deleteGroupMember: PropTypes.func.isRequired,
        groupStackState: IPropTypes.record.isRequired,
        loadGroupMembers: PropTypes.func.isRequired,
        members: PropTypes.array.isRequired,
        openDialog: PropTypes.func.isRequired,
        resizeGroupStack: PropTypes.func.isRequired,
    }

    handleOnResize = (width, height) => {
        const { resizeGroupStack } = this.props

        resizeGroupStack(height)
    }

    renderContent = () => {
        const {
            groupStackState: {
                groupData: { loading, page, pages },
                membersPerPage,
                activeGroup: activeGroupId,
            },
            members,
            deleteGroupMember,
            loadGroupMembers,
            openDialog,
        } = this.props

        if (_.isEmpty(members) && page === 0 && !loading) {
            return <EmptyContent openDialog={openDialog} />
        }

        return (
            <TableContent
                members={members}
                loading={loading}
                loadGroupMembers={loadGroupMembers}
                activeGroupId={activeGroupId}
                page={page}
                pages={pages}
                deleteGroupMember={deleteGroupMember}
                membersPerPage={membersPerPage}
            />
        )
    }

    render() {
        const { connectDropTarget } = this.props

        return connectDropTarget(
            <div className={'group-stack-content'}>
                {this.renderContent()}
                <ReactResizeDetector
                    onResize={this.handleOnResize}
                    refreshMode={'debounce'}
                    refreshRate={200}
                    handleHeight
                />
            </div>
        )
    }
}
